import React from "react"
import classnames from "classnames"
import _map from "lodash/map"
import compose from "ramda/src/compose"
import { translate } from "react-i18next"
import PropTypes from "prop-types"

import Typograph from "components/Typograph"
import Popover from "react-popover"
import ThemeConsumer from "shared/components/ThemeConsumer"

const Options = ({ options, trigger, isOpen, theme, t, onClose }) => {
  const contentClasses = classnames(theme.containerOptions, theme.pv3)

  const content = (
    <ul className={contentClasses}>
      {_map(options, ({ label, id, handleClick }) => {
        return (
          <li key={id}>
            <button
              id={id}
              onClick={() => {
                handleClick()
                onClose()
              }}
            >
              <Typograph
                htmlTag="span"
                weight="semi_bold"
                size="small"
                color="outer_space"
              >
                {label}
              </Typograph>
            </button>
          </li>
        )
      })}
    </ul>
  )

  return (
    <Popover
      isOpen={isOpen}
      onOuterAction={onClose}
      tipSize={0.01}
      preferPlace="left"
      place="left"
      body={content}
    >
      {trigger()}
    </Popover>
  )
}

Options.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      id: PropTypes.string,
      handleClick: PropTypes.func
    })
  ),
  trigger: PropTypes.func,
  isOpen: PropTypes.bool,
  theme: PropTypes.shape({
    containerOptions: PropTypes.string,
    pv3: PropTypes.string
  }),
  t: PropTypes.func,
  onClose: PropTypes.func
}

const enhance = compose(translate())

export default enhance(ThemeConsumer("UIInvoicesPaid")(Options))



// WEBPACK FOOTER //
// ./src/components/InvoicesPaid/components/Options.js